import styled, { css } from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

import { Flex } from 'Components/UI'

export const Container = styled(Flex)`
  flex-direction: column;
  justify-content: space-between;
`
export const RowWrapper = styled(Flex)`
  &:last-child {
    margin: 0;
  }
`

const dotTransparentCss = ({ transparent }) =>
  transparent &&
  css`
    background-color: transparent;
  `

const dotPrimaryCss = ({ primary }) =>
  primary &&
  css`
    background-color: ${themeGet('colors.softPeach')};
  `

const dotSecondaryCss = ({ secondary }) =>
  secondary &&
  css`
    background-color: ${themeGet('colors.nightBlue')};
  `

const shouldForwardProp = prop => {
  return !['primary', 'secondary', 'transparent'].includes(String(prop))
}

export const Dot = styled(Flex).withConfig({
  shouldForwardProp,
})`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: ${themeGet('colors.calculator.dot')};
  &:last-child {
    margin: 0;
  }

  ${dotTransparentCss}
  ${dotPrimaryCss}
  ${dotSecondaryCss}
`
